/* eslint-disable */
/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import {
  ServiceType,
  InboundType,
  InboundInsuranceOnDateOfService,
  Benefit,
  NjmmisCheckStatus,
} from './globalTypes' // ====================================================
// GraphQL mutation operation: StartInbound
// ====================================================

import {StartInboundVariables as StartInboundVariablesOrig} from '../types/StartInbound'
import {StartInbound as StartInboundOrig} from '../types/StartInbound'
import {StartInbound_startInbound as StartInbound_startInboundOrig} from '../types/StartInbound'
import {StartInbound_startInbound_account as StartInbound_startInbound_accountOrig} from '../types/StartInbound'
import {StartInbound_startInbound_mostRecentNjmmisCheck as StartInbound_startInbound_mostRecentNjmmisCheckOrig} from '../types/StartInbound'
import {StartInbound_startInbound_personFormData as StartInbound_startInbound_personFormDataOrig} from '../types/StartInbound'
import {StartInbound_startInbound_person as StartInbound_startInbound_personOrig} from '../types/StartInbound'
import {AdditionalData} from 'utils/getAdditionalData'
import {parseAdditionalData} from 'utils/getAdditionalData'
import {serializeAdditionalData} from 'utils/getAdditionalData'
import formatISO from 'date-fns/formatISO'
import {parseDate} from 'utils/form/fieldTypes'
import {formatISODate} from 'utils/date'
import {StartInbound_startInbound_person_mostRecentEligibilityDeterminations as StartInbound_startInbound_person_mostRecentEligibilityDeterminationsOrig} from '../types/StartInbound'
import {BenefitType} from 'utils/benefits'
import {deserializeBenefit} from 'graphql/converters'
import {serializeBenefit} from 'graphql/converters'
import {StartInbound_startInbound_person_openApplications as StartInbound_startInbound_person_openApplicationsOrig} from '../types/StartInbound'
import {StartInbound_startInbound_completedBy as StartInbound_startInbound_completedByOrig} from '../types/StartInbound'
import {StartInbound_startInbound_startedBy as StartInbound_startInbound_startedByOrig} from '../types/StartInbound'
export interface StartInbound_startInbound_startedBy {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeStartInbound_startInbound_startedBy = (
  serialized: StartInbound_startInbound_startedByOrig
): StartInbound_startInbound_startedBy => ({...serialized})
export const serializeStartInbound_startInbound_startedBy = (
  deserialized: StartInbound_startInbound_startedBy
): StartInbound_startInbound_startedByOrig => ({...deserialized})
export interface StartInbound_startInbound_completedBy {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeStartInbound_startInbound_completedBy = (
  serialized: StartInbound_startInbound_completedByOrig
): StartInbound_startInbound_completedBy => ({...serialized})
export const serializeStartInbound_startInbound_completedBy = (
  deserialized: StartInbound_startInbound_completedBy
): StartInbound_startInbound_completedByOrig => ({...deserialized})
export interface StartInbound_startInbound_person_openApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeStartInbound_startInbound_person_openApplications = (
  serialized: StartInbound_startInbound_person_openApplicationsOrig
): StartInbound_startInbound_person_openApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeStartInbound_startInbound_person_openApplications = (
  deserialized: StartInbound_startInbound_person_openApplications
): StartInbound_startInbound_person_openApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface StartInbound_startInbound_person_mostRecentEligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeStartInbound_startInbound_person_mostRecentEligibilityDeterminations = (
  serialized: StartInbound_startInbound_person_mostRecentEligibilityDeterminationsOrig
): StartInbound_startInbound_person_mostRecentEligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeStartInbound_startInbound_person_mostRecentEligibilityDeterminations = (
  deserialized: StartInbound_startInbound_person_mostRecentEligibilityDeterminations
): StartInbound_startInbound_person_mostRecentEligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface StartInbound_startInbound_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  middleName: string | null
  lastName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  openApplications: StartInbound_startInbound_person_openApplications[]
  mostRecentEligibilityDeterminations: StartInbound_startInbound_person_mostRecentEligibilityDeterminations[]
}
export const deserializeStartInbound_startInbound_person = (
  serialized: StartInbound_startInbound_personOrig
): StartInbound_startInbound_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  openApplications: serialized.openApplications.map(
    deserializeStartInbound_startInbound_person_openApplications
  ),
  mostRecentEligibilityDeterminations: serialized.mostRecentEligibilityDeterminations.map(
    deserializeStartInbound_startInbound_person_mostRecentEligibilityDeterminations
  ),
})
export const serializeStartInbound_startInbound_person = (
  deserialized: StartInbound_startInbound_person
): StartInbound_startInbound_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  openApplications: deserialized.openApplications.map(
    serializeStartInbound_startInbound_person_openApplications
  ),
  mostRecentEligibilityDeterminations: deserialized.mostRecentEligibilityDeterminations.map(
    serializeStartInbound_startInbound_person_mostRecentEligibilityDeterminations
  ),
})
export interface StartInbound_startInbound_personFormData {
  __typename: 'InboundPersonFormData'
  firstName: string | null
  lastName: string | null
  dob: Date | null
  phoneNumber: string | null
}
export const deserializeStartInbound_startInbound_personFormData = (
  serialized: StartInbound_startInbound_personFormDataOrig
): StartInbound_startInbound_personFormData => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
})
export const serializeStartInbound_startInbound_personFormData = (
  deserialized: StartInbound_startInbound_personFormData
): StartInbound_startInbound_personFormDataOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
})
export interface StartInbound_startInbound_mostRecentNjmmisCheck {
  __typename: 'NjmmisCheck'
  id: string
  status: NjmmisCheckStatus
  medicaidId: string | null
  eligibleServices: string[] | null
}
export const deserializeStartInbound_startInbound_mostRecentNjmmisCheck = (
  serialized: StartInbound_startInbound_mostRecentNjmmisCheckOrig
): StartInbound_startInbound_mostRecentNjmmisCheck => ({...serialized})
export const serializeStartInbound_startInbound_mostRecentNjmmisCheck = (
  deserialized: StartInbound_startInbound_mostRecentNjmmisCheck
): StartInbound_startInbound_mostRecentNjmmisCheckOrig => ({...deserialized})
export interface StartInbound_startInbound_account {
  __typename: 'Account'
  id: string
  department: string
  insuranceType: string
}
export const deserializeStartInbound_startInbound_account = (
  serialized: StartInbound_startInbound_accountOrig
): StartInbound_startInbound_account => ({...serialized})
export const serializeStartInbound_startInbound_account = (
  deserialized: StartInbound_startInbound_account
): StartInbound_startInbound_accountOrig => ({...deserialized})
export interface StartInbound_startInbound {
  __typename: 'Inbound'
  id: string
  reason: string
  dateOfService: Date | null
  serviceType: ServiceType | null
  createdAt: Date
  lastIntakeWebformReceivedAt: Date | null
  inboundType: InboundType
  insuranceOnDateOfService: InboundInsuranceOnDateOfService | null
  startedBy: StartInbound_startInbound_startedBy | null
  startedAt: Date | null
  completedBy: StartInbound_startInbound_completedBy | null
  completedAt: Date | null
  person: StartInbound_startInbound_person | null
  personFormData: StartInbound_startInbound_personFormData | null
  mostRecentNjmmisCheck: StartInbound_startInbound_mostRecentNjmmisCheck | null
  account: StartInbound_startInbound_account | null
}
export const deserializeStartInbound_startInbound = (
  serialized: StartInbound_startInboundOrig
): StartInbound_startInbound => ({
  ...serialized,
  dateOfService:
    serialized.dateOfService != null
      ? parseDate(serialized.dateOfService)
      : serialized.dateOfService,
  createdAt: parseDate(serialized.createdAt),
  lastIntakeWebformReceivedAt:
    serialized.lastIntakeWebformReceivedAt != null
      ? parseDate(serialized.lastIntakeWebformReceivedAt)
      : serialized.lastIntakeWebformReceivedAt,
  startedBy:
    serialized.startedBy != null
      ? deserializeStartInbound_startInbound_startedBy(serialized.startedBy)
      : serialized.startedBy,
  startedAt:
    serialized.startedAt != null
      ? parseDate(serialized.startedAt)
      : serialized.startedAt,
  completedBy:
    serialized.completedBy != null
      ? deserializeStartInbound_startInbound_completedBy(serialized.completedBy)
      : serialized.completedBy,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
  person:
    serialized.person != null
      ? deserializeStartInbound_startInbound_person(serialized.person)
      : serialized.person,
  personFormData:
    serialized.personFormData != null
      ? deserializeStartInbound_startInbound_personFormData(
          serialized.personFormData
        )
      : serialized.personFormData,
  mostRecentNjmmisCheck:
    serialized.mostRecentNjmmisCheck != null
      ? deserializeStartInbound_startInbound_mostRecentNjmmisCheck(
          serialized.mostRecentNjmmisCheck
        )
      : serialized.mostRecentNjmmisCheck,
  account:
    serialized.account != null
      ? deserializeStartInbound_startInbound_account(serialized.account)
      : serialized.account,
})
export const serializeStartInbound_startInbound = (
  deserialized: StartInbound_startInbound
): StartInbound_startInboundOrig => ({
  ...deserialized,
  dateOfService:
    deserialized.dateOfService != null
      ? formatISODate(deserialized.dateOfService)
      : deserialized.dateOfService,
  createdAt: formatISO(deserialized.createdAt),
  lastIntakeWebformReceivedAt:
    deserialized.lastIntakeWebformReceivedAt != null
      ? formatISO(deserialized.lastIntakeWebformReceivedAt)
      : deserialized.lastIntakeWebformReceivedAt,
  startedBy:
    deserialized.startedBy != null
      ? serializeStartInbound_startInbound_startedBy(deserialized.startedBy)
      : deserialized.startedBy,
  startedAt:
    deserialized.startedAt != null
      ? formatISO(deserialized.startedAt)
      : deserialized.startedAt,
  completedBy:
    deserialized.completedBy != null
      ? serializeStartInbound_startInbound_completedBy(deserialized.completedBy)
      : deserialized.completedBy,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
  person:
    deserialized.person != null
      ? serializeStartInbound_startInbound_person(deserialized.person)
      : deserialized.person,
  personFormData:
    deserialized.personFormData != null
      ? serializeStartInbound_startInbound_personFormData(
          deserialized.personFormData
        )
      : deserialized.personFormData,
  mostRecentNjmmisCheck:
    deserialized.mostRecentNjmmisCheck != null
      ? serializeStartInbound_startInbound_mostRecentNjmmisCheck(
          deserialized.mostRecentNjmmisCheck
        )
      : deserialized.mostRecentNjmmisCheck,
  account:
    deserialized.account != null
      ? serializeStartInbound_startInbound_account(deserialized.account)
      : deserialized.account,
})
export interface StartInbound {
  /**
   * Start inbound
   */
  startInbound: StartInbound_startInbound
}
export const deserializeStartInbound = (
  serialized: StartInboundOrig
): StartInbound => ({
  ...serialized,
  startInbound: deserializeStartInbound_startInbound(serialized.startInbound),
})
export const serializeStartInbound = (
  deserialized: StartInbound
): StartInboundOrig => ({
  ...deserialized,
  startInbound: serializeStartInbound_startInbound(deserialized.startInbound),
})
export interface StartInboundVariables {
  id: string
  associateWithPersonHavingMrn?: string | null
}
export const deserializeStartInboundVariables = (
  serialized: StartInboundVariablesOrig
): StartInboundVariables => ({...serialized})
export const serializeStartInboundVariables = (
  deserialized: StartInboundVariables
): StartInboundVariablesOrig => ({...deserialized})
